<template>
  <div class="bg-[#798B97] flex justify-start items-start pt-[19px] pb-[18px] px-[15px] md:px-[36px] h-full w-full">
    <Sidebar @setBranchId="handleBranchId" :isActiveSidebar="isActiveSidebar" @handleSidebar="handleSidebar" />
    <HomePage :branchId="branchId" :isActiveSidebar="isActiveSidebar" @handleSidebar="handleSidebar" />
  </div>
</template>

<script>


import Sidebar from "@/layout/includes/Sidebar.vue";

import HomePage from "@/pages/Home.vue";

export default {
  name: 'LayoutVue',
  components: {
    HomePage,
    Sidebar
  },
  data(){
    return {
      branchId: null,
      isActiveSidebar: false
    }
  },

  methods: {
    handleBranchId(id){
      this.branchId = id;
    },

    handleSidebar(){
      this.isActiveSidebar = !this.isActiveSidebar;
    }
  }
}
</script>

<style>
</style>
